import { render, staticRenderFns } from "./artistupload.vue?vue&type=template&id=5bcfd256&scoped=true&"
import script from "./artistupload.vue?vue&type=script&lang=ts&"
export * from "./artistupload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcfd256",
  null
  
)

export default component.exports